import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, CheckCircle, Car, Calendar } from 'lucide-react';

type Activity = {
  id: number;
  icon: React.ReactNode;
  color: string;
  title: string;
  time: string;
  description: string;
};

const ActivityFeed: React.FC = () => {
  const activities: Activity[] = [
    {
      id: 1,
      icon: <MessageSquare size={16} />,
      color: 'bg-accent text-background',
      title: 'New message from John',
      time: '10 min ago',
      description: 'Question about ceramic coating package'
    },
    {
      id: 2,
      icon: <CheckCircle size={16} />,
      color: 'bg-success text-white',
      title: 'Service completed',
      time: '2 hours ago',
      description: 'Full interior detail for BMW X5'
    },
    {
      id: 3,
      icon: <Car size={16} />,
      color: 'bg-warning text-background',
      title: 'New appointment',
      time: 'Today',
      description: 'Premium wash & wax - Tesla Model 3'
    },
    {
      id: 4,
      icon: <Calendar size={16} />,
      color: 'bg-white/20 text-white',
      title: 'Upcoming booking',
      time: 'Tomorrow',
      description: 'Full paint correction - Porsche 911'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -10 },
    visible: { 
      opacity: 1, 
      x: 0,
      transition: { duration: 0.3 }
    }
  };

  return (
    <motion.div 
      className="rounded-xl bg-white/5 backdrop-blur-sm border border-white/10 h-full overflow-hidden"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <div className="p-4 border-b border-white/10 flex justify-between items-center">
        <h3 className="font-semibold">Recent Activity</h3>
        <motion.button 
          className="text-xs px-2 py-1 rounded bg-white/10 hover:bg-white/20"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          View All
        </motion.button>
      </div>
      
      <div className="p-2 overflow-y-auto max-h-[240px]">
        {activities.map((activity) => (
          <motion.div 
            key={activity.id}
            className="p-3 rounded-lg hover:bg-white/5 transition-colors cursor-pointer"
            variants={itemVariants}
          >
            <div className="flex items-start space-x-3">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${activity.color} flex-shrink-0`}>
                {activity.icon}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-start">
                  <p className="font-medium text-sm truncate">{activity.title}</p>
                  <span className="text-xs text-white/50 whitespace-nowrap ml-2">{activity.time}</span>
                </div>
                <p className="text-xs text-white/70 mt-1">{activity.description}</p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ActivityFeed;